(function () {
  var campagne = window.MGMCampagne;
  if (!campagne) return;

  // L'image du pack remplace seulement l'image affichée : data-color-map reste intact car le configurateur de pack le relit.
  function apply(option) {
    var radio = option.querySelector('.mgm-variant-selector__radio');
    if (!radio) return;
    var pack = campagne.packs[radio.getAttribute('data-variant-id')];
    var img = option.querySelector('.mgm-variant-selector__image');
    if (img && pack && pack.image && img.getAttribute('src') !== pack.image) img.setAttribute('src', pack.image);
    decorate(option, pack);
    summarize(option.closest('.mgm-variant-selector'));
    var line = option.querySelector('.mgm-variant-selector__gifts');
    if (!pack || !pack.inclus) {
      if (line) line.remove();
      return;
    }
    if (!line) {
      line = document.createElement('p');
      line.className = 'mgm-variant-selector__gifts';
      var anchor = option.querySelector('.mgm-variant-selector__subtitle') || option.querySelector('.mgm-variant-selector__title');
      if (!anchor) return;
      anchor.insertAdjacentElement('afterend', line);
    }
    if (line.textContent !== pack.inclus) line.textContent = pack.inclus;
  }

  function packOf(option) {
    var radio = option.querySelector('.mgm-variant-selector__radio');
    return radio && campagne.packs[radio.getAttribute('data-variant-id')];
  }

  // À partir de 3 offres, l'étiquette et les cadeaux identiques sont regroupés au-dessus du sélecteur au lieu d'être répétés sur chaque carte.
  function summarize(selector) {
    if (!selector || !campagne.habillage) return;
    var options = selector.querySelectorAll('.mgm-variant-selector__option');
    var packs = Array.prototype.map.call(options, packOf);
    var inclus = packs[0] && packs[0].inclus;
    var compact = options.length >= 3 && !!inclus && packs.every(function (p) { return p && p.inclus === inclus; });
    selector.classList.toggle('mgm-hab-compact', compact);
    var strip = selector.previousElementSibling && selector.previousElementSibling.classList.contains('mgm-hab-strip') ? selector.previousElementSibling : null;
    if (!compact) {
      if (strip) strip.remove();
      return;
    }
    if (!strip) {
      strip = document.createElement('p');
      strip.className = 'mgm-hab-strip';
      strip.innerHTML = '<span class="mgm-hab-strip__label"></span><span class="mgm-hab-strip__text"></span>';
      selector.insertAdjacentElement('beforebegin', strip);
    }
    var label = strip.querySelector('.mgm-hab-strip__label');
    label.textContent = campagne.etiquette || '';
    label.hidden = !campagne.etiquette;
    var text = inclus.replace(/^\s*\+\s*/, '');
    var node = strip.querySelector('.mgm-hab-strip__text');
    if (node.textContent !== text) node.textContent = text;
  }

  function decorate(option, pack) {
    if (!campagne.habillage) return;
    option.classList.add('mgm-hab-option');
    if (!option.querySelector('.mgm-hab-deco')) {
      option.insertAdjacentHTML('beforeend', '<span class="mgm-hab-deco mgm-hab-deco--a" aria-hidden="true"></span><span class="mgm-hab-deco mgm-hab-deco--b" aria-hidden="true"></span>');
    }
    var label = option.querySelector('.mgm-hab-label');
    var text = pack && campagne.etiquette;
    option.classList.toggle('mgm-hab-option--labeled', !!text);
    if (!text) {
      if (label) label.remove();
      return;
    }
    if (!label) {
      label = document.createElement('span');
      label.className = 'mgm-hab-label';
      option.appendChild(label);
    }
    if (label.textContent !== text) label.textContent = text;
  }

  // Coupure mobile avant le dernier mot, ou à l'endroit d'un | dans le texte du métaobjet.
  function twoLines(span, text) {
    var parts = text.indexOf('|') !== -1 ? text.split('|') : [text.slice(0, text.lastIndexOf(' ')), text.slice(text.lastIndexOf(' ') + 1)];
    span.textContent = '';
    span.setAttribute('data-hab-text', text);
    if (!parts[0]) {
      span.textContent = text;
      return;
    }
    parts = [parts[0].trim() + ' ', parts.slice(1).join(' ').trim()];
    parts.forEach(function (part, k) {
      if (k) {
        var br = document.createElement('br');
        br.className = 'mgm-hab-br';
        span.appendChild(br);
      }
      var line = document.createElement('span');
      line.className = 'mgm-hab-line';
      line.textContent = part;
      span.appendChild(line);
    });
  }

  function announcements() {
    var texts = campagne.annonces;
    if (!texts.length) return;
    document.querySelectorAll('.brand-header__announcement-inner').forEach(function (inner) {
      inner.querySelectorAll('.brand-header__announcement-item').forEach(function (item, i) {
        var span = item.querySelector('.brand-header__announcement-text');
        if (i >= texts.length) {
          item.setAttribute('data-campagne-hidden', '');
          return;
        }
        if (span && span.getAttribute('data-hab-text') !== texts[i]) twoLines(span, texts[i]);
      });
    });
    document.documentElement.setAttribute('data-hab-annonces', 'ok');
  }

  function stickyCta() {
    if (!campagne.cta) return;
    document.querySelectorAll('.brand-sticky__cta .ui-btn__label').forEach(function (label) {
      if (!label.hasAttribute('data-hab-original')) label.setAttribute('data-hab-original', label.textContent.trim());
      var remise = label.getAttribute('data-hab-original').match(/(\d+)\s?%/);
      label.textContent = campagne.cta + (remise ? ' -' + remise[1] + '%' : '');
    });
  }

  function replaceTexts() {
    campagne.remplacements.forEach(function (rule) {
      var pair = rule.split('=>');
      if (pair.length !== 2) return;
      var from = pair[0].trim();
      var to = pair[1].trim();
      document.querySelectorAll('.mgm-focus-header__title').forEach(function (el) {
        if (el.textContent.indexOf(from) !== -1) el.textContent = el.textContent.replace(from, to);
      });
    });
  }

  function hide(el, off) {
    if (off) el.setAttribute('data-campagne-hidden', '');
    else el.removeAttribute('data-campagne-hidden');
  }

  function uncheck(input) {
    if (!input || !input.checked) return;
    input.checked = false;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function pageProductId(el) {
    var root = el.closest('.mgm-add-to-cart') || document;
    var host = root.querySelector('[data-upsell-product-id], [data-product-id]');
    return host ? host.getAttribute('data-upsell-product-id') || host.getAttribute('data-product-id') : null;
  }

  function cleanUpsells(container) {
    var gifted = campagne.giftedVariants([container.getAttribute('data-upsell-product-id')]);
    var nodes = Array.prototype.filter.call(container.children, function (n) { return !n.hasAttribute('data-mgm-skeleton'); });
    function visible(n) {
      return n.classList.contains('mgm-upsell-card') && !n.hasAttribute('data-campagne-hidden') && !n.hasAttribute('data-mgm-upsell-hidden');
    }
    nodes.forEach(function (n) {
      if (!n.classList.contains('mgm-upsell-card')) return;
      var off = !!gifted[n.getAttribute('data-upsell-variant-id')];
      hide(n, off);
      if (off) uncheck(n.querySelector('input[type="checkbox"]'));
    });
    var cardBefore = false;
    nodes.forEach(function (n, i) {
      if (visible(n)) cardBefore = true;
      if (!n.classList.contains('mgm-upsell-separator')) return;
      var show = cardBefore && nodes.slice(i + 1).some(visible);
      hide(n, !show);
      if (show) cardBefore = false;
    });
    hide(container, !container.hasAttribute('data-mgm-upsell-loading') && !nodes.some(visible));
  }

  function cleanWarranty(input) {
    var gifted = campagne.giftedVariants([pageProductId(input)]);
    var option = input.closest('.mgm-warranty-option');
    if (!option || !gifted[input.getAttribute('data-warranty-variant-id')]) return;
    uncheck(input);
    hide(option, true);
  }

  var packOpened = {};

  function packOffer(wrapper, text) {
    var root = wrapper.closest('.mgm-add-to-cart') || document;
    var title = root.querySelector('.mgm-qty2-toggle__title');
    if (!title) return;
    var line = title.parentNode.querySelector('.mgm-pack-offer');
    if (!text) {
      if (line) line.remove();
      return;
    }
    if (!line) {
      line = document.createElement('p');
      line.className = 'mgm-pack-offer';
      title.insertAdjacentElement('afterend', line);
    }
    if (line.textContent !== text) line.textContent = text;
  }

  function renderCodeMessages(cart) {
    var codes = ((cart && cart.discount_codes) || []).map(function (d) { return String(d.code).toUpperCase(); });
    document.querySelectorAll('.mgm-variant-selector-wrapper').forEach(function (wrapper) {
      var pid = pageProductId(wrapper);
      var hit = campagne.messages.filter(function (m) {
        return codes.indexOf(m.code) !== -1 && (!m.produits.length || m.produits.indexOf(pid) !== -1);
      })[0];
      var box = wrapper.previousElementSibling && wrapper.previousElementSibling.classList.contains('mgm-code-message') ? wrapper.previousElementSibling : null;
      packOffer(wrapper, hit && hit.packTexte);
      if (!hit) {
        if (box) box.remove();
        return;
      }
      if (!box) {
        box = document.createElement('div');
        box.className = 'mgm-code-message';
        box.setAttribute('role', 'status');
        box.innerHTML = '<span class="mgm-code-message__code"></span><span class="mgm-code-message__text"></span>';
        wrapper.insertAdjacentElement('beforebegin', box);
      }
      box.querySelector('.mgm-code-message__code').textContent = hit.code;
      box.querySelector('.mgm-code-message__text').textContent = hit.texte;
      if (hit.pack && !packOpened[hit.code]) {
        packOpened[hit.code] = true;
        var tiers = String(hit.paliers || '').split('|').map(function (t) { return t.split(':').map(Number); })
          .filter(function (t) { return t.length === 2 && !isNaN(t[0]) && !isNaN(t[1]); });
        document.dispatchEvent(new CustomEvent('mgm:pack', { detail: { qty: hit.pack, tiers: tiers } }));
      }
    });
  }

  function refreshCodeMessages() {
    if (!campagne.messages.length || !document.querySelector('.mgm-variant-selector-wrapper')) return;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(renderCodeMessages)
      .catch(function () {});
  }

  function init() {
    refreshCodeMessages();
    if (!campagne.handle) return;
    announcements();
    stickyCta();
    replaceTexts();
    document.querySelectorAll('.mgm-upsells[data-upsell-product-id]').forEach(function (container) {
      if (container.dataset.campagneReady) return;
      container.dataset.campagneReady = '1';
      cleanUpsells(container);
      new MutationObserver(function () { cleanUpsells(container); }).observe(container, {
        childList: true,
        attributes: true,
        attributeFilter: ['data-mgm-upsell-loading']
      });
    });
    document.querySelectorAll('.mgm-warranty-checkbox[data-warranty-variant-id]').forEach(cleanWarranty);
    document.querySelectorAll('.mgm-variant-selector__option').forEach(function (option) {
      if (option.dataset.campagneReady) return;
      option.dataset.campagneReady = '1';
      apply(option);
      new MutationObserver(function () { apply(option); }).observe(option, {
        attributes: true,
        subtree: true,
        attributeFilter: ['src', 'data-variant-id']
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  ['mgm:codes-applied', 'mgm:gift:synced', 'product:added-to-cart'].forEach(function (name) {
    document.addEventListener(name, refreshCodeMessages);
  });
})();
